<template>
  <div class="options" >
    <el-divider content-position="left">基础信息</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpen">添加</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="medium" border style="width: 100%">
      <el-table-column label='id'>
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column label='公司名'>
        <template slot-scope="scope">
          {{scope.row.company_name}}
        </template>
      </el-table-column>
      <el-table-column label='联系方式'>
        <template slot-scope="scope">
          {{scope.row.phone}}
        </template>
      </el-table-column>
      <el-table-column label='地址'>
        <template slot-scope="scope">
          {{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column label='东经'>
        <template slot-scope="scope">
          {{scope.row.x}}
        </template>
      </el-table-column>
      <el-table-column label='北纬'>
        <template slot-scope="scope">
          {{scope.row.y}}
        </template>
      </el-table-column>
      <el-table-column label='type'>
        <template slot-scope="scope">
          {{scope.row.type}}
        </template>
      </el-table-column>
      <el-table-column label='创建时间'>
        <template slot-scope="scope">
          {{scope.row.created_at}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-drawer
      title="添加"
      :visible.sync="addDrawer"
      :direction="direction"
      :before-close="handleAddDrawerClose"
      size="50%">
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/upload/option/cover'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleAddCoverSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="addCoverUrl" :src="addCoverUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="m-tabs-content">
        <el-row>
          <el-input
            placeholder="公司名"
            v-model="addData.company_name"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="联系方式"
            v-model="addData.phone"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="地址"
            v-model="addData.address"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="东经"
            v-model="addData.x"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="北纬"
            v-model="addData.y"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="type"
            v-model="addData.type"
            clearable>
          </el-input>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleAdd">添加</el-button>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑"
      :visible.sync="saveDrawer"
      :direction="direction"
      :before-close="handleSaveDrawerClose"
      size="50%">
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/upload/option/cover'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleSaveCoverSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="saveCoverUrl" :src="saveCoverUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="m-tabs-content">
        <el-row>
          <el-input
            placeholder="公司名"
            v-model="saveData.company_name"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="联系方式"
            v-model="saveData.phone"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="地址"
            v-model="saveData.address"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="东经"
            v-model="saveData.x"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="北纬"
            v-model="saveData.y"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="type"
            v-model="saveData.type"
            clearable>
          </el-input>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Options',
  data () {
    return {

      uploadHeader: {Authorization: localStorage.token},
      imgPath: this.$store.state.imgPath,
      option: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      addDrawer: false,
      addCoverUrl: '',
      direction: 'rtl',
      saveDrawer: false,
      saveCoverUrl: '',
      addData: {
        cover: '',
        company_name: '',
        phone: '',
        address: '',
        x: '',
        y: '',
        type: ''
      },
      saveData: {
        id: null,
        index: null,
        cover: '',
        company_name: '',
        phone: '',
        address: '',
        x: '',
        y: '',
        type: ''
      }
    }
  },
  computed: {
    pageData: {
      get: function () {
        return this.option.slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
      }
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development' ? '' : 'https://weixin.qiyehuo.com'
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getData () {
      this.$axios.get('/api/admin/programOption')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.option = data.data
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    handleAddOpen () {
      this.addDrawer = true
    },
    beforeAvatarUpload (file) {
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$message.error('封面只能是 JPG、PNG 格式!')
        return false
      }

      return true
    },
    handleAddCoverSuccess (res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw)
        this.addData.cover = this.imgPath + res.data.store_result
      } else {
        this.$message.error(res.msg)
      }
    },
    handleAddDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearAddData()
          done()
        })
        .catch(_ => {})
    },
    clearAddData () {
      this.addData.cover = ''
      this.addCoverUrl = ''
      this.addData.company_name = ''
      this.addData.phone = ''
      this.addData.address = ''
      this.addData.x = ''
      this.addData.y = ''
      this.addData.type = ''
    },
    handleAdd () {
      if (!this.addData.type) {
        this.$message.error('type不能为空')
        return
      }

      this.$axios.post('/api/admin/programOption', this.addData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.option.unshift(data.data)
            this.option.total = this.option.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.addDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },

    handleEdit (index, row) {
      this.saveData.id = row.id
      this.saveData.index = index
      this.saveData.cover = row.cover
      this.saveCoverUrl = row.cover
      this.saveData.company_name = row.company_name
      this.saveData.phone = row.phone
      this.saveData.address = row.address
      this.saveData.x = row.x
      this.saveData.y = row.y
      this.saveData.type = row.type
      this.saveDrawer = true
    },

    handleSaveCoverSuccess (res, file) {
      if (res.code === 0) {
        this.saveCoverUrl = URL.createObjectURL(file.raw)
        this.saveData.cover = this.imgPath + res.data.store_result
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSaveDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {})
    },
    clearSaveData () {
      this.saveData.id = null
      this.saveData.index = null
      this.saveData.cover = ''
      this.saveCoverUrl = ''
      this.saveData.company_name = ''
      this.saveData.phone = ''
      this.saveData.address = ''
      this.saveData.x = ''
      this.saveData.y = ''
      this.saveData.type = ''
    },
    handleSave () {
      if (!this.saveData.type) {
        this.$message.error('type不能为空')
        return
      }

      this.$axios.post('/api/admin/programOption/update', this.saveData).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + this.saveData.index
          this.option[index].cover = this.saveData.cover
          this.option[index].company_name = this.saveData.company_name
          this.option[index].phone = this.saveData.phone
          this.option[index].address = this.saveData.address
          this.option[index].x = this.saveData.x
          this.option[index].y = this.saveData.y
          this.option[index].type = this.saveData.type
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawer = false
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .el-dialog__wrapper >>> .el-drawer
    overflow-y: auto
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
  .addCon
    margin: .2rem 0
    text-align: right
  .el-row
    margin-bottom: .2rem
  .avatar-uploader
    text-align: center
    margin-bottom: .2rem
  .avatar-uploader >>> .el-upload
    border: .02rem dashed #d9d9d9
    border-radius: .12rem
    cursor: pointer
    position: relative
    overflow: hidden
  .avatar-uploader >>> .el-upload:hover
    border-color: #409eff
  .avatar-uploader >>> .el-upload img
    width: 4rem
    height: 2rem
  .avatar-uploader-icon
    font-size: .4rem
    color: #8c939d
    width: 4rem
    height: 2rem
    line-height: 2rem
    text-align: center
  .options
    marginLeft()
</style>



// WEBPACK FOOTER //
// src/pages/options/Options.vue